<template>
  <div>
    <div class="l-container">

      <h1 class="m-label">生徒ファイル</h1>
      <tr-c slot="tr-th">
        <th-c>id</th-c>
        <th-c>student_id</th-c>
        <th-c>user_id</th-c>
        <th-c>month</th-c>
        <th-c>filing_date</th-c>
        <th-c>note</th-c>
        <th-c>ファイル名</th-c>
        <th-c>作成日</th-c>
      </tr-c>
      <tr-c slot="tr-td">
        <td-c>{{studentfile.id}}</td-c>
        <td-c>{{studentfile.student_id}}</td-c>
        <td-c>{{studentfile.user_id}}</td-c>
        <td-c>{{studentfile.month}}</td-c>
        <td-c>{{studentfile.filing_date}}</td-c>
        <td-c>{{studentfile.note}}</td-c>
        <td-c>{{studentfile.file_name}}</td-c>
        <td-c>{{studentfile.created_at}}</td-c>
      </tr-c>

    </div>

    <template v-if="studentfile.id">
      <iframe v-bind:src="files + studentfile.id + '_s.pdf'" frameborder="0"></iframe>
    </template>

  </div>
</template>

<script>
import { getFILE } from '@/store/getters.js'
const files = getFILE()

export default {
  data () {
    return {
      files: files
    }
  },
  computed: {
    studentfile () {
      return this.$store.getters.studentfile
    }
  },
  methods: {
    getStudentfile (id) {
      this.$store.dispatch('getStudentfile', {
        id: id
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStudentfile(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 185px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// Studentfile.vue?77f7a5ce